import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
/**
 * 获取快捷注释
 **/
export function getQuickCommentsApi() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/predefined/comment`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 编辑快捷注释
 **/
export function editQuickCommentsApi(commentId, commentList) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/predefined/comment/${commentId}`,
        method: 'PUT',
        data: commentList,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getPatentViewCommentsListApi(patent_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
export function editPatentViewCommentApi({ patent_id, comment_text, comment_id, comment_to, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}/comment/${comment_id}`,
        method: 'PUT',
        data: {
            patent_id,
            comment_text,
            comment_id,
            comment_to,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function createPatentViewCommentApi({ comment_by, comment_to, comment_to_id, comment_text, wording_id, patent_id, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}`,
        method: 'POST',
        data: {
            comment_by,
            comment_to,
            comment_text,
            comment_to_id,
            wording_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function deletePatentViewCommentApi({ patent_id, comment_id, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}/comment/${comment_id}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function postCommentListApi(params) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/console/list`,
        method: 'POST',
        transformCode: true,
        data: {
            ...params,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function postVisibleScopeApi(params) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/console/visible-scope`,
        method: 'POST',
        data: {
            ...params,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getCommentSpaceListApi(space_name) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/console/filter-space-list`,
        method: 'GET',
        transformCode: true,
        data: {
            space_name,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getCommentEditableSpaceListApi(space_name) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/console/edit-space-list`,
        method: 'GET',
        transformCode: true,
        data: {
            space_name,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
